@if(!!loginForm) {
  <img (click)="openDevSettings()" src="assets/images/logo_etrasa.png">

  <div class="login-format">
    <!-- Login App -->
    @if(!devSettings && !insertTotp) {
      <form class="form" (ngSubmit)="login()" [formGroup]="loginForm">
        <div class="inputs-container">
          <h1>Oráculo Etrasa</h1>
          <h3>Iniciar sesión</h3>
          <input type="email" formControlName="email" name="email" id="input-email" class="form-control input-custom" placeholder="Usuario"
            #emailInput (keydown.enter)="passwordInput.focus(); $event.preventDefault()">
          <input type="password" formControlName="password" name="password" id="input-password" class="form-control input-custom" placeholder="Contraseña" maxlength="50"
            #passwordInput (keydown.enter)="(loginForm.valid && !loginInProcess) ? login() : null; $event.preventDefault()">
          <div class="password-options-container">
            <p (click)="recoverPassword()" class="recover-password">Olvidé mi contraseña</p>
            <p (click)="showPassword()" class="show-password">Mostrar contraseña</p>
          </div>
          <!-- <p class="checkbox-text">
            <input type="checkbox" class="checkbox" [(ngModel)]="loginForm.rememberUser" name="rememberUser" #rememberUser="ngModel">
            Recordar usuario
          </p> -->
        </div>

        @if(wrongLogin) {
          <p class="message-error">{{errorMessage}}</p>
        }

        <div class="button-container">
          <button class="enter-button" type="submit" [disabled]="loginForm.invalid || loginInProcess">Entrar</button>
        </div>
      </form>
    }

    <!-- Insert TOTP code -->
    @if(insertTotp) {
      <form class="form">
        <div class="inputs-container">
          <h1>Oráculo Etrasa</h1>

          @if(!!totpRegisterAuth) {
            <div class="qr-container">
              <p class="qr-info-text">Escanea este código con tu app de autenticación.</p>
              <qrcode [qrdata]="totpRegisterAuth.qrCode" [width]="150"></qrcode>

              <p class="qr-info-text">¿No puedes escanear? Introduce este código manualmente:</p>

              <div class="manual-entry-key-container">
                <p class="manual-entry-key">{{totpRegisterAuth.manualEntryKey}}</p>

                <button class="copy-button" (click)="copyManualKey()">Copiar</button>
              </div>
            </div>
          }

          <h3>Introduce código TOTP</h3>

          <input type="text" autofocus [(ngModel)]="totpCode" name="text" id="input-email" class="form-control input-custom" placeholder="Código TOTP" [readonly]="verifyTotpInProcess"
            #totpCodeInput (keydown.enter)="totpCode.trim() !== '' ? verifyMethod() : null; $event.preventDefault()">
        </div>

        @if(verifyMethodError !== '') {
          <p class="verify-method-error">{{verifyMethodError}}</p>
        }

        <div class="button-container">
          <button class="enter-button" (click)="goToLogin()" [disabled]="verifyTotpInProcess">Volver a Login</button>

          <button (click)="verifyMethod()" class="enter-button" type="submit" [disabled]="totpCode.trim() === '' || verifyTotpInProcess">Verificar</button>
        </div>
      </form>
    }

    @if(devSettings) {
      @if(!logDevSettings) {
        <!-- Login devSettings -->
        <div class="login-dev-settings-container">
          <h2>Ajustes de desarrollador</h2>
          <input type="password" [(ngModel)]="passwordDevSettings" placeholder="Contraseña" class="login-dev-settings-input"
            (keydown.enter)="changeLogDevSettings(); $event.preventDefault()">

          @if(wrongPasswordDevSettings) {
            <div class="error-message">
              <label>Contraseña incorrecta</label>
            </div>
          }

          <div class="url-selector-buttons">
            <button class="enter-button" (click)="goToLogin()">Volver a Login</button>

            <button class="enter-button" (click)="changeLogDevSettings()">Confirmar</button>
          </div>
        </div>
      } @else {
        <!-- devSettings -->
        <div class="url-selector-container">
          <form class="form" [ngClass]="{'fieldset-big': logDevSettings}">
            <fieldset class="fieldset">
              <legend>Selecciona la URL de la API</legend>
              <label>
                <input type="radio" name="apiUrl" [(ngModel)]="selectedApiUrl" [value]="environmentEtrasaApiUrl">
                {{environmentEtrasaApiUrl.name}} - {{environmentEtrasaApiUrl.url}}
              </label><br>
              @for(apiUrl of apiUrls; track apiUrl.name) {
                <label>
                  <input type="radio" name="apiUrl" [(ngModel)]="selectedApiUrl" [value]="apiUrl">
                  {{apiUrl.name}} - {{apiUrl.url}}
                </label><br>
              }
            </fieldset>

            <div class="url-selector-buttons">
              <button type="button" (click)="goToLogin()">Volver a Login</button>

              <button type="button" (click)="selectApiUrl()">Seleccionar</button>
            </div>
          </form>
        </div>
      }  
    }
  </div>
}